import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Modal, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import TextareaAutosize from 'react-autosize-textarea';
import { putRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import { timezoneStringLabel } from '../../dateUtils';
import CalendarOptions from '../common/CalendarOptions';
import TimezoneSelector from '../common/TimezoneSelector';
import './ScheduleInterviewConsultant.scss';
var datesGroupedByMonth = function datesGroupedByMonth(days) {
  var hash = {};
  days.forEach(function (el) {
    if (!hash[el.month()]) {
      hash[el.month()] = [];
    }
    hash[el.month()].push(el);
  });
  return hash;
};
var adjustTimeToZone = function adjustTimeToZone(time, tz1, tz2) {
  return utcToZonedTime(zonedTimeToUtc(time, tz1), tz2);
};
var convertedAvailabilities = function convertedAvailabilities(availabilities, tz1, tz2) {
  return availabilities.map(function (availability) {
    var d = moment("".concat(availability.date, " ").concat(availability.start_time)).toDate();
    var adjusted = adjustTimeToZone(d, tz1, tz2);
    var m = moment(adjusted);
    return {
      date: m.format('YYYY-MM-DD'),
      start_time: m.format('HH:mm'),
      initial_value: d.valueOf(),
      moment: m
    };
  });
};
var ScheduleInterviewConsultant = /*#__PURE__*/function (_Component) {
  function ScheduleInterviewConsultant(props) {
    var _this;
    _classCallCheck(this, ScheduleInterviewConsultant);
    _this = _callSuper(this, ScheduleInterviewConsultant, [props]);
    _this.state = {
      timezone: _this.props.timezone,
      showModal: false,
      showSendNotificationModal: false,
      selectedDate: null,
      selectedTime: null,
      schedulingIssue: false,
      rescheduleNote: ''
    };
    _this.location = 'Consultant Interview Booking Page';
    _this.handleTimezoneChange = _this.handleTimezoneChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleDateSelect = _this.handleDateSelect.bind(_this);
    _this.handleTimeSelect = _this.handleTimeSelect.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleToggleSchedulingIssue = _this.handleToggleSchedulingIssue.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    return _this;
  }
  _inherits(ScheduleInterviewConsultant, _Component);
  return _createClass(ScheduleInterviewConsultant, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      analyticsTrack('User visited interview slot selection page for consultants', {
        location: this.location
      });
    }
  }, {
    key: "ableToSubmit",
    value: function ableToSubmit() {
      var _this$state = this.state,
        timezone = _this$state.timezone,
        selectedDate = _this$state.selectedDate,
        selectedTime = _this$state.selectedTime,
        schedulingIssue = _this$state.schedulingIssue;
      return schedulingIssue || timezone && selectedDate && selectedTime;
    }
  }, {
    key: "validTimeExists",
    value: function validTimeExists() {
      var _this$props = this.props,
        timeSlots = _this$props.timeSlots,
        interviewTimezone = _this$props.interviewTimezone;
      var now = new Date();
      return timeSlots.reduce(function (aggr, avail) {
        var val = zonedTimeToUtc(moment("".concat(avail.date, " ").concat(avail.start_time)).toDate(), interviewTimezone).valueOf();
        return aggr || val > now.valueOf();
      }, false);
    }
  }, {
    key: "localTime",
    value: function localTime() {
      var utcSeconds = new Date().valueOf() + new Date().getTimezoneOffset() * 60 * 1000;
      return adjustTimeToZone(new Date(utcSeconds), 'UTC', this.state.timezone);
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      analyticsTrack("User clicked 'Send Time'", {
        location: this.location
      });
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleDateSelect",
    value: function handleDateSelect(e) {
      var date = e.target.dataset.date;
      this.setState({
        selectedDate: new Date(Number(date))
      });
    }
  }, {
    key: "handleTimeSelect",
    value: function handleTimeSelect(e) {
      analyticsTrack('User selected time', {
        location: this.location
      });
      var dateTime = e.target.dataset.time;
      this.setState({
        selectedTime: new Date(Number(dateTime))
      });
    }
  }, {
    key: "handleTimezoneChange",
    value: function handleTimezoneChange(newTimezone) {
      var timezone = this.state.timezone;
      if (timezone === null) {
        analyticsTrack('User selected timezone', {
          location: this.location
        });
      }
      this.setState({
        timezone: newTimezone,
        selectedDate: null,
        selectedTime: null
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false,
        errors: null
      });
    }
  }, {
    key: "handleToggleSchedulingIssue",
    value: function handleToggleSchedulingIssue() {
      var schedulingIssue = this.state.schedulingIssue;
      if (!schedulingIssue) {
        analyticsTrack("User checked 'No Times Work'", {
          location: this.location
        });
      }
      this.setState({
        schedulingIssue: !this.state.schedulingIssue
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value) {
      this.setState({
        rescheduleNote: value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props2 = this.props,
        updateInterviewUrl = _this$props2.updateInterviewUrl,
        csrfToken = _this$props2.csrfToken,
        proposalResourceId = _this$props2.proposalResourceId,
        interviewLength = _this$props2.interviewLength,
        proposalUrl = _this$props2.proposalUrl;
      var _this$state2 = this.state,
        schedulingIssue = _this$state2.schedulingIssue,
        selectedTime = _this$state2.selectedTime,
        timezone = _this$state2.timezone,
        rescheduleNote = _this$state2.rescheduleNote;
      var startTime = moment(selectedTime).format('HH:mm');
      var endTime = moment(selectedTime).add(interviewLength, 'minutes').format('HH:mm');
      var date = moment(selectedTime).format('YYYY-MM-DD');
      var params = {
        proposal_resource_id: proposalResourceId,
        reschedule_requested: schedulingIssue,
        reschedule_note: rescheduleNote,
        interview: {
          accepted_time: {
            date: date,
            start_time: startTime,
            end_time: endTime
          },
          timezone: timezone
        }
      };
      putRequest(updateInterviewUrl, params, csrfToken).then(function () {
        analyticsTrack('User selected interview time', {
          location: _this2.location
        });
        window.location.href = proposalUrl;
      })["catch"](function (error) {
        _this2.setState({
          errors: error
        });
        return null;
      });
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      if (!errors) return null;
      var message = errors.error || "We're sorry, this timeslot is no longer available. Please choose another.";
      return /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("h3", null, message));
    }
  }, {
    key: "renderTimezoneSelect",
    value: function renderTimezoneSelect() {
      var _this3 = this;
      var timezone = this.state.timezone;
      return /*#__PURE__*/React.createElement("div", {
        className: "timezone-select mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "timezone-select-label body-text-2 medium-weight mb-2"
      }, "1. Select your time zone"), /*#__PURE__*/React.createElement(TimezoneSelector, {
        onChange: function onChange(newTz) {
          return _this3.handleTimezoneChange(newTz);
        },
        selectedValue: timezone
      }));
    }
  }, {
    key: "renderCalendarOptions",
    value: function renderCalendarOptions() {
      var _this4 = this;
      var _this$state3 = this.state,
        schedulingIssue = _this$state3.schedulingIssue,
        selectedDate = _this$state3.selectedDate,
        timezone = _this$state3.timezone;
      var _this$props3 = this.props,
        timeSlots = _this$props3.timeSlots,
        interviewTimezone = _this$props3.interviewTimezone;
      var converted = convertedAvailabilities(timeSlots, interviewTimezone, timezone);
      var days = converted.filter(function (ts) {
        return ts.moment > _this4.localTime().valueOf() + 3600000;
      }).map(function (a) {
        return moment(a.date);
      });
      var groupedDates = datesGroupedByMonth(days);
      var months = [];
      Object.keys(groupedDates).forEach(function (month) {
        months.push(month);
      });
      months = months.sort(function (a, b) {
        return groupedDates[a][0].valueOf() - groupedDates[b][0].valueOf();
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "calendar-options-component-container body-text-2 ".concat(schedulingIssue ? 'disabled' : '')
      }, "2. Select the day that fits your schedule among the available ones", /*#__PURE__*/React.createElement("div", {
        className: "calendar-container"
      }, months.map(function (month) {
        return /*#__PURE__*/React.createElement(CalendarOptions, {
          key: moment(groupedDates[month][0]).startOf('month').toDate(),
          startDate: moment(groupedDates[month][0]).startOf('month').toDate(),
          availableDays: groupedDates[month].map(function (date) {
            return date.date();
          }),
          updateSelection: _this4.handleDateSelect,
          selectedDate: selectedDate,
          disabled: schedulingIssue
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "legend"
      }, /*#__PURE__*/React.createElement("div", {
        className: "available-times"
      }, "\xA0\xA0Available times"), /*#__PURE__*/React.createElement("div", {
        className: "selected-day"
      }, "\xA0\xA0Selected day"), /*#__PURE__*/React.createElement("div", {
        className: "no-times-available"
      }, "\xA0\xA0No times on that day"))));
    }
  }, {
    key: "renderTimeOptions",
    value: function renderTimeOptions() {
      var _this5 = this;
      var _this$props4 = this.props,
        timeSlots = _this$props4.timeSlots,
        interviewTimezone = _this$props4.interviewTimezone;
      var _this$state4 = this.state,
        schedulingIssue = _this$state4.schedulingIssue,
        selectedDate = _this$state4.selectedDate,
        selectedTime = _this$state4.selectedTime,
        timezone = _this$state4.timezone;
      var correctedSelectedDate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
      var timeSlotsForChosenDay = convertedAvailabilities(timeSlots, interviewTimezone, timezone).filter(function (ts) {
        return ts.date && ts.date === correctedSelectedDate.toISOString().slice(0, 10) && ts.moment > _this5.localTime().valueOf() + 3600000;
      }).sort(function (a, b) {
        return a.moment.valueOf() - b.moment.valueOf();
      });
      var adjustedFirstTimeSlot = selectedDate && moment("".concat(timeSlotsForChosenDay[0].date, " ").concat(timeSlotsForChosenDay[0].start_time));
      return /*#__PURE__*/React.createElement("div", {
        className: "time-options-component-container ".concat(schedulingIssue ? 'disabled' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight"
      }, /*#__PURE__*/React.createElement("br", null), "3. Pick a time to meet on", ' ', adjustedFirstTimeSlot.format('dddd, MMM Do'), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Row, {
        className: "time-options"
      }, timeSlotsForChosenDay.map(function (ts) {
        var time = moment("".concat(ts.date, " ").concat(ts.start_time));
        var selected = !schedulingIssue && selectedTime && ts.initial_value === selectedTime.valueOf() ? 'selected' : '';
        return /*#__PURE__*/React.createElement(Col, {
          xs: 6,
          sm: 4,
          md: 3,
          lg: 2
        }, /*#__PURE__*/React.createElement("div", {
          className: "interview-time-option ".concat(selected),
          "data-time": ts.initial_value,
          onClick: _this5.handleTimeSelect,
          role: "button",
          tabIndex: "0"
        }, time.format('hh:mm A')));
      }))));
    }
  }, {
    key: "renderSchedulingIssueCheckbox",
    value: function renderSchedulingIssueCheckbox() {
      return /*#__PURE__*/React.createElement("div", {
        className: "scheduling-issue"
      }, /*#__PURE__*/React.createElement("label", {
        className: "custom-checkbox-container",
        htmlFor: "schedulingIssue"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        onClick: this.handleToggleSchedulingIssue,
        id: "schedulingIssue"
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text"
      }, "I did not find a day and a time that works for me."), /*#__PURE__*/React.createElement("div", {
        className: "checkbox-subheading"
      }, "Employer will be notified to provide new timeslots.")));
    }
  }, {
    key: "renderSubmitButton",
    value: function renderSubmitButton() {
      var _this6 = this;
      var disabled = !this.ableToSubmit();
      var schedulingIssue = this.state.schedulingIssue;
      var tooltipCopy = 'Please pick an interview time.';
      var onSubmit = function onSubmit() {
        return !disabled && _this6.handleShowModal();
      };
      var submitButton = function submitButton() {
        return /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary submit-button ".concat(disabled && 'disabled'),
          onClick: onSubmit
          // can't use disabled prop here because a disabled button also disables the OverlayTrigger
          // instead, we prefer to check !disabled ourselves
        }, schedulingIssue ? 'Request Reschedule' : 'Send Time');
      };
      var possiblyWrappedButton = function possiblyWrappedButton() {
        return disabled ? /*#__PURE__*/React.createElement(OverlayTrigger, {
          placement: "left",
          delay: 200,
          overlay: /*#__PURE__*/React.createElement(Tooltip, {
            id: "cannot-submit-tooltip"
          }, tooltipCopy)
        }, submitButton()) : submitButton();
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "submit-button-container g-row--always g-row-justify-right g-flex-align-center"
      }, /*#__PURE__*/React.createElement("br", null), possiblyWrappedButton());
    }
  }, {
    key: "renderConfirmationModal",
    value: function renderConfirmationModal() {
      var _this7 = this;
      var _this$state5 = this.state,
        schedulingIssue = _this$state5.schedulingIssue,
        selectedTime = _this$state5.selectedTime,
        showModal = _this$state5.showModal,
        timezone = _this$state5.timezone,
        rescheduleNote = _this$state5.rescheduleNote;
      var _this$props5 = this.props,
        projectName = _this$props5.projectName,
        interviewLength = _this$props5.interviewLength,
        interviewTimezone = _this$props5.interviewTimezone;
      var adjustedStartTime = adjustTimeToZone(selectedTime || new Date(), interviewTimezone, timezone);
      var formattedDate = moment(adjustedStartTime).format('ddd, MMM D YYYY');
      var formattedStartTime = moment(adjustedStartTime).format('h:mm');
      var endTime = moment(adjustedStartTime).add(interviewLength, 'minutes');
      var formattedEndTime = moment(endTime).format('h:mm A');
      var formattedTimeZone = timezone ? timezoneStringLabel(timezone) : null;
      var heading = schedulingIssue ? 'We will reschedule this interview' : 'You are about to schedule your interview';
      return /*#__PURE__*/React.createElement(Modal, {
        className: "confirm-interview",
        show: showModal,
        onHide: this.handleHideModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, this.renderErrors(), /*#__PURE__*/React.createElement("div", {
        className: "modal-headline"
      }, heading), !schedulingIssue && /*#__PURE__*/React.createElement("div", {
        className: "modal-subtext"
      }, "Conference meeting link will be shared via email by Clora."), schedulingIssue ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", null, "A notification will be sent indicating that the available times do not work for you. Could you provide information regarding your availability to help us with rescheduling the interview?"), /*#__PURE__*/React.createElement(TextareaAutosize, {
        className: "interview-reschedule-note",
        id: "interview-reschedule-note",
        rows: 2,
        value: rescheduleNote,
        onChange: function onChange(e) {
          return _this7.handleInputChange(e.target.value);
        },
        placeholder: "Please enter reschedule reason"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "modal-details"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time-details"
      }, "".concat(formattedDate, " - ").concat(formattedStartTime, " - ").concat(formattedEndTime)), /*#__PURE__*/React.createElement("span", {
        className: "timezone-text"
      }, formattedTimeZone), /*#__PURE__*/React.createElement("br", null), projectName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Row, {
        className: "center"
      }, /*#__PURE__*/React.createElement(Col, {
        xs: 6
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary modal-button",
        onClick: this.handleCloseModal
      }, "Back to times")), /*#__PURE__*/React.createElement(Col, {
        xs: 6
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary modal-button",
        onClick: this.handleSubmit,
        disabled: schedulingIssue && !rescheduleNote
      }, schedulingIssue ? 'Submit' : 'Yes, Schedule')))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        projectName = _this$props6.projectName,
        interviewLength = _this$props6.interviewLength;
      var _this$state6 = this.state,
        timezone = _this$state6.timezone,
        selectedDate = _this$state6.selectedDate,
        schedulingIssue = _this$state6.schedulingIssue;
      if (!this.validTimeExists()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "expired-message"
        }, /*#__PURE__*/React.createElement("div", {
          className: "header"
        }, "Contact Clora for assistance."), /*#__PURE__*/React.createElement("div", {
          className: "subtext"
        }, "It looks like the available times have expired and are no longer available. Please reach out to Clora for assistance."));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "consultants-interview-scheduler-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, "Schedule your interview: ".concat(projectName)), /*#__PURE__*/React.createElement("div", {
        className: "subtext"
      }, interviewLength, ' ', "mins")), /*#__PURE__*/React.createElement("div", {
        className: "padded-modal-content"
      }, this.renderTimezoneSelect(), timezone && this.renderCalendarOptions(), selectedDate && this.renderTimeOptions(), timezone && this.renderSchedulingIssueCheckbox(), (selectedDate || schedulingIssue) && this.renderSubmitButton(), this.renderConfirmationModal()));
    }
  }]);
}(Component);
ScheduleInterviewConsultant.propTypes = {
  updateInterviewUrl: PropTypes.string.isRequired,
  proposalUrl: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  timezone: PropTypes.string,
  interviewTimezone: PropTypes.string,
  timeSlots: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    start_time: PropTypes.string,
    end_time: PropTypes.string
  })).isRequired,
  projectName: PropTypes.string.isRequired,
  interviewLength: PropTypes.number.isRequired
};
ScheduleInterviewConsultant.defaultProps = {
  timezone: null,
  interviewTimezone: null
};
export default ScheduleInterviewConsultant;